var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{ref:"videoPlayer",attrs:{"disableremoteplayback":"","disablepictureinpicture":"","muted":"","playsinline":"","preload":"auto","x-webkit-airplay":"deny"},domProps:{"muted":true,"currentTime":_vm.videoProgress},on:{"loadedmetadata":_vm.logDuration}},[_c('source',{attrs:{"type":"video/mp4"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }